import { styled, Typography } from '@mui/material'
import IconButton, { IconButtonProps } from '@mui/material/IconButton'

export const StyledISelectorIconButton = styled((props: IconButtonProps) => (
  <IconButton disableRipple disableFocusRipple disableTouchRipple {...props} />
))(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
  color: '#8E8E93',
}))

export const StyledCardLabel = styled(Typography)(({ theme }) => ({
  width: '100%',
  textAlign: 'start',
  padding: theme.spacing(2, 0, 2, 1.5),
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  '& :first-letter': {
    textTransform: 'capitalize',
  },
}))
